import {Grid} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {getGPLUCoverageDefinitionPropertyPaths, getGPLUExclusionsAndLimitationsPropertyPaths} from '../PropertyPaths';
import {AccelDeathBenefitType, GPLU_ACDB_FIELD_ID, GPLUCoverageCode} from '../../../PlanTemplates/GWL/gpluConstants';

export const GPLUAccelDeathCoverageDefinitionsBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue, updateQuoteFieldValues} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);
  const situsStateCd = getQuoteFieldValue<string>('riskStateCd');
  const propertyPaths = getGPLUCoverageDefinitionPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);
  const preExclusionPaths = getGPLUExclusionsAndLimitationsPropertyPaths(
    selectedPlan?.planIndex,
    selectedCoverageIndex
  );

  const handleAccelDeathBenefittype = (benefitType: string) => {
    let fieldsToUpdate: {path: string; newValue: any}[] = [
      {path: propertyPaths.accelDeathBenefitTypeCd, newValue: benefitType},
    ];

    if (benefitType === AccelDeathBenefitType.LTC_Basic && situsStateCd !== 'TX') {
      fieldsToUpdate.push(
        {path: preExclusionPaths.preExConditionLimitationCd, newValue: 'PreEx'},
        {path: preExclusionPaths.lookBackPeriodCd, newValue: '6'},
        {path: preExclusionPaths.preExConditionLimitationPeriodCd, newValue: '6'}
      );
    }
    updateQuoteFieldValues(fieldsToUpdate);
  };
  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'coverage-definitions-row-1'},
      items: [
        {
          key: propertyPaths.accelDeathBenefitTypeCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="Accel. Death Benefit Type"
              dropdownVariant="AttributeValue"
              searchKey="AccelDeathBenefitCoverage.accelDeathBenefitTypeCd"
              id={propertyPaths.accelDeathBenefitTypeCd}
              value={getQuoteFieldValue(propertyPaths.accelDeathBenefitTypeCd)}
              onChange={e => handleAccelDeathBenefittype(e.target.value as string)}
              coverageCode={GPLUCoverageCode.ACCEL_DEATH_BENEFIT_LIFE}
              type="number"
              required
            />
          ),
        },
        {
          key: propertyPaths.eliminationPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Elimination Period"
              id={propertyPaths.eliminationPeriod}
              value={getQuoteFieldValue(propertyPaths.eliminationPeriod)}
              onChange={e => updateQuoteFieldValue(propertyPaths.eliminationPeriod, Number(e.target.value))}
              formFieldId={GPLU_ACDB_FIELD_ID.eliminationPeriod}
              type="number"
              required
              disabled
            />
          ),
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Coverage Definition" collapsible expanded withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
